import React, { useEffect } from 'react';
import { Autocomplete, TextField, Checkbox } from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Downgraded, useState } from '@hookstate/core';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
import { makeStyles } from '@mui/styles';
// const theme = createTheme();

const useStyles = makeStyles(() => ({
    textField: {
        '& .MuiFormLabel-root': {
            textTransform: 'capitalize',
        },
    },
    autoComplete: {
        // "& .MuiAutocomplete-inputRoot": {
        //     paddingRight: theme.spacing(5),
        // }
    },
}));

const Filter = (props) =>
{
    const classes = useStyles();
    const filterData = useState([]);

    useEffect(() =>
    {
        if (props.data)
        {
            filterData.set(props.data);
        }
    }, [props]);

    const getFilterData = (value, label) =>
    {
        let filterObj = {};
        filterObj[label] = value;
        props.setFilters(label, value);
    };

    return (
        <>
            {filterData.get() && (
                <Autocomplete
                    size="small"
                    multiple={props.label == 'requestStatus' || props.label == 'transportType' ? false : true}
                    limitTags={1}
                    id="multiple-limit-tags"
                    options={filterData.attach(Downgraded).get()}
                    getOptionLabel={(option) => option}
                    onChange={(event, value) =>
                        getFilterData(value, props.label)
                    }
                    renderOption={(props, option, { selected }) => (
                        <li {...props}>
                            <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                            />
                            {option}
                        </li>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={
                                props.label.toLowerCase() == 'participant'
                                    ? 'Participants'
                                    : props.label.toLowerCase() ==
                                        'requeststatus'
                                        ? 'Status'
                                        : props.label == 'transportType' ?
                                            'Type'
                                            : props.label
                            }
                            placeholder={
                                props.label.toLowerCase() == 'participant'
                                    ? 'Participants'
                                    : props.label.toLowerCase() ==
                                        'requeststatus'
                                        ? 'Status'
                                        : props.label == 'transportType' ?
                                            'Type'
                                            : props.label
                            }
                            className={classes.textField}
                        />
                    )}
                    sx={{ width: props.label == 'transportType' ? '150px' : '240px', mt: 1, mb: 1, ml: 0, mr: 1 }}
                    renderTags={(option) =>
                    {
                        //console.log('option',option , props.tag);
                        //getFilterData(option,props.tag)
                        if (option.length == 1)
                        {
                            return option[0];
                        } else
                        {
                            let str =
                                option[0] + ' + ' + (option.length - 1) + '...';
                            return str;
                        }
                    }}
                    className={classes.autoComplete}
                />
            )}
        </>
    );
};

export default Filter;
